import { useGetActiveCustomEmployeeFieldsQuery } from '@/app/features/control-panel/organization';

/** Every custom field value lives under this one key in the employee form. */
export const CUSTOM_FIELDS_KEY = 'custom_fields';

/**
 * The active fields a company defined, in display order.
 *
 * Screens use it to decide whether an "Additional Information" tab or panel is
 * worth showing at all: a company with no custom fields gets no new surface.
 */
export const useActiveCustomFields = () => {
  const { data, isLoading } = useGetActiveCustomEmployeeFieldsQuery();
  return { fields: data?.data || [], isLoading };
};
